import { forwardRef, useCallback } from 'react';
import { BoxProps } from '@chakra-ui/react';
import { Button } from '@mercator-gcp/grout';
import { useSubmitForm, useFormState } from 'hooks/projectGroupEdit/useProjectGroupForm';
import { useCloneQuery } from 'state/queryParams';

type TProps = {
  sx?: BoxProps['sx'];
};

const SaveGroupButton = forwardRef<HTMLButtonElement, TProps>(({ sx = {} }, ref) => {
  const { submitSaveGroup, submitUpdateGroup, isLoading } = useSubmitForm();
  const { validateProjectGroupForm } = useFormState();
  const { cloneQuery } = useCloneQuery();
  const isDuplicating = !!cloneQuery;

  const handleSaveClick = useCallback(() => {
    if (isLoading || !validateProjectGroupForm()) {
      return;
    }
    if (isDuplicating) {
      submitSaveGroup();
    } else {
      submitUpdateGroup();
    }
  }, [validateProjectGroupForm, isLoading, isDuplicating]);

  return (
    <Button
      ref={ref}
      sx={sx}
      onClick={handleSaveClick}
      variant="primary"
      isLoading={isLoading}
      isDisabled={isLoading}
    >
      {isDuplicating ? 'Save' : 'Update'}
    </Button>
  );
});

export default SaveGroupButton;
